export enum AssignmentFeedbackType {
  GRAMMAR = 'grammar',
  SPELLING = 'spelling',
  VOCABULARY = 'vocabulary',
  PUNCTUATION = 'punctuation',
  STYLE = 'style',
  CLARITY = 'clarity',
  COHERENCE = 'coherence',
  ORGANIZATION = 'organization',
  FORMAT = 'format',
  TONE = 'tone',
  OTHER = 'other',
  PRIVATE = 'private',
}

export default class AssignmentFeedback {
  public readonly id?: string;
  public submission_id: string;
  public text: string;
  public start_index?: number;
  public end_index?: number;
  public correction_type: AssignmentFeedbackType;
  public question?: string;
  public translation?: string;

  constructor(
    submission_id: string,
    text: string,
    correction_type: AssignmentFeedbackType,
    start_index?: number,
    end_index?: number,
    id?: string,
    question?: string,
    translation?: string,
  ) {
    this.id = id;
    this.submission_id = submission_id;
    this.text = text;
    this.start_index = start_index;
    this.end_index = end_index;
    this.correction_type = correction_type;
    this.question = question;
    this.translation = translation;
  }

  static fromServerFeedback(feedback: Record<string, any>): AssignmentFeedback {
    return new AssignmentFeedback(
      feedback['submission'],
      feedback['text'],
      feedback['correction_type'] as AssignmentFeedbackType,
      feedback['start_index'],
      feedback['end_index'],
      feedback['id'],
      feedback['question'],
      feedback['translation'],
    );
  }

  static fromFeedback(feedback: AssignmentFeedback): AssignmentFeedback {
    return new AssignmentFeedback(
      feedback.submission_id,
      feedback.text,
      feedback.correction_type,
      feedback.start_index,
      feedback.end_index,
      feedback.id,
      feedback.question,
      feedback.translation,
    );
  }

  static generateDefault(
    submissionId: string,
    questionId?: string,
    start_index?: number,
    end_index?: number,
  ): AssignmentFeedback {
    return new AssignmentFeedback(
      submissionId,
      '',
      AssignmentFeedbackType.OTHER,
      start_index,
      end_index,
      undefined,
      questionId,
    );
  }

  toJSON(): Record<string, any> {
    return {
      id: this.id,
      submission: this.submission_id,
      text: this.text,
      start_index: this.start_index,
      end_index: this.end_index,
      correction_type: this.correction_type,
      question: this.question,
      translation: this.translation,
    };
  }
}
